import React from "react";

interface TextInputProps {
  value: string | null;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
  autoFocus?: boolean;
}

const TextInput: React.FC<TextInputProps> = ({
  value,
  onChange,
  placeholder,
  className = "",
  inputRef,
  autoFocus,
}) => (
  <input
    ref={inputRef}
    type="text"
    value={value ?? ""}
    onChange={(e) => onChange(e.target.value)}
    placeholder={placeholder}
    autoFocus={autoFocus}
    className={`w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-[var(--fp-ink-3)] focus:border-[var(--fp-ink-3)] ${className}`}
  />
);

export default TextInput;
